// extracted by mini-css-extract-plugin
export var changeIcon = "_3r-4";
export var container = "_3r-0";
export var divider = "_3r-7";
export var externalLinkIcon = "_3r-1";
export var green = "_3r-5";
export var helpCircleIcon = "_3r-3";
export var iconButton = "_3r-2";
export var red = "_3r-6";